// Google Tag Manager Tracking Utility
// Agendario Admin - Event Tracking
import { isDevEnvironment } from './environment';

/**
 * Track custom event to Google Tag Manager
 * @param {string} eventName - Event name (e.g., 'agenda_created')
 * @param {object} eventData - Event data object
 */
export function trackEvent(eventName, eventData = {}) {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: eventName,
      timestamp: new Date().toISOString(),
      ...eventData
    });
    
    // Debug logging in development
    if (isDevEnvironment()) {
      console.debug('[GTM Event]', eventName, eventData);
    }
  } else {
    console.warn('[GTM] dataLayer not found. Event not tracked:', eventName);
  }
}

/**
 * Track error event with context
 * @param {string} errorType - Error type (e.g., 'api_error', 'validation_error')
 * @param {Error|string} error - Error object or message
 * @param {object} context - Additional context
 */
export function trackError(errorType, error, context = {}) {
  const errorMessage = error?.message || error || 'Unknown error';
  const errorStack = error?.stack || '';
  
  trackEvent('error_occurred', {
    error_type: errorType,
    error_message: errorMessage,
    error_stack: errorStack.substring(0, 500), // Limit stack trace size
    ...context
  });
}

/**
 * Track page view (for SPA navigation)
 * @param {string} pageName - Page name (e.g., 'agendas', 'professionals')
 */
export function trackPageView(pageName) {
  trackEvent('page_view', {
    page_name: pageName,
    page_url: window.location.pathname
  });
}

/**
 * Track form abandonment
 * @param {string} formName - Form name
 * @param {object} formData - Current form data (for completion analysis)
 */
export function trackFormAbandonment(formName, formData = {}) {
  // Count filled fields
  const totalFields = Object.keys(formData).length;
  const filledFields = Object.values(formData).filter(v => v !== '' && v !== null && v !== undefined).length;
  const completionRate = totalFields > 0 ? (filledFields / totalFields * 100).toFixed(0) : 0;
  
  trackEvent('form_abandoned', {
    form_name: formName,
    completion_rate: completionRate,
    filled_fields: filledFields,
    total_fields: totalFields
  });
}

export default {
  trackEvent,
  trackError,
  trackPageView,
  trackFormAbandonment
};
